module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURXyCjEdwTHyBi3iAiHyCjXuCi3yCjHyAi3yCjHqAihdeQrYAAAAKdFJOU/4AgBrfZZtCxDDPGqkyAAAA80lEQVQoz32SPQ/CIBCGT6WNK9L6sbX9BZo0zpj6A0TjjouuGj/mGo3O/mM5aBso0VsgD9zLy90B9QJ+otuTzBzEEgBw0QXCs5s4gHdbKwn1dp2pEBoNQJhTjI5Gx4C2b/G07SsmntWoyqMcjCjQ48JDcucllicP8ZmH3PLMPx5KUkROohSo9XHQCU0IG3HUWt0tMiH44rRnoWGIaNy1EJ4DHYGlj79TrmTRkBgdKZT3G2erwLSD8UdzKa06lBNjjclu3TRWko1aRhJEVFTdjjm8sj3Ag0ZqNEwd4lK1kBxQt6hLw67ZVr+bE2++2PLPyNnxBdFBPoFxP6jXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.png
// module id = /DBc
// module chunks = 0